import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import TextField from '@mui/material/TextField';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import FilterListIcon from '@mui/icons-material/FilterList';

import { IUsersFilterState } from '../../types/users';

interface IProps {
  visibility: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  filters: [IUsersFilterState, React.Dispatch<React.SetStateAction<IUsersFilterState>>];
  onApplyFilters(): void;
  onClearFilters(): void;
}

function Filters(props: IProps) {
  const [visible, toggleVisibility] = props.visibility;
  const [filters, setFilters] = props.filters;

  function handleChange(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  }

  return (
    <Box sx={{ mb: 1 }}>
      <Button
        color="primary"
        startIcon={<FilterListIcon />}
        onClick={() => toggleVisibility(!visible)}
      >
        {`${visible ? 'Hide' : 'Show'} Filters`}
      </Button>
      <Collapse in={visible}>
        <Card elevation={0} sx={{ backgroundColor: 'transparent' }}>
          <CardContent sx={{ padding: 0 }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', '& > div:not(:last-child)': { mr: 1 } }}>
              <TextField
                sx={{ mt: 1 }}
                variant="outlined"
                size="small"
                label="First Name"
                name="firstName"
                value={filters.firstName}
                onChange={handleChange}
              />
              <TextField
                sx={{ mt: 1 }}
                variant="outlined"
                size="small"
                label="Last Name"
                name="lastName"
                value={filters.lastName}
                onChange={handleChange}
              />
              <TextField
                sx={{ mt: 1 }}
                variant="outlined"
                size="small"
                label="Email"
                name="email"
                value={filters.email}
                onChange={handleChange}
              />
              <TextField
                sx={{ mt: 1 }}
                variant="outlined"
                size="small"
                label="Employee Id"
                name="empId"
                value={filters.empId}
                onChange={handleChange}
              />
            </Box>
          </CardContent>
          <CardActions sx={{ pl: 0, pr: 0, justifyContent: 'end' }}>
            <Button variant="contained" color="primary" size="small" onClick={props.onApplyFilters}>
              Apply
            </Button>
            <Button variant="outlined" size="small" onClick={props.onClearFilters}>
              Clear
            </Button>
          </CardActions>
        </Card>
      </Collapse>
    </Box>
  );
}

export default Filters;
